export const CLIENT_STATES = [
  "unavailable", // 0
  "present",     // 1
  "waiting",     // 2
  "authorized",  // 3
  "denied",      // 4
  "done",        // 5
  "cancelled",   // 6
  "active",      // 7
  "expired",     // 8
  "hidden",      // 9
];

export const getEnv = (key: string): string => {
  const env = (import.meta as any).env;
  if (env && env[key] !== undefined) {
    return String(env[key]);
  }
  if (typeof process !== 'undefined' && process.env && process.env[key] !== undefined) {
    return String(process.env[key]);
  }
  return '';
};

export const CLIENT_STATE_DISPLAYS = (clientLink: string, clientName: string, session: string) => ({
  unavailable: session ? `${clientName || "client"} is not connected` : "waiting for client",
  present: `someone's at ${clientLink}`,
  waiting: `${clientName} is waiting`,
  authorized: `waiing for ${clientName} to join`,
  denied: `${clientName} was denied`,
  done: "You ended the session.",
  cancelled: `${clientName} cancelled request`,
  active: `${clientName} is active`,
  expired: `${clientName}'s session expired.`,
  hidden: `${clientName || "client"}'s window is hidden`,
});

export const DEFAULT_PRESET_NAME = "Basic Settings";
export const NEW_PRESET_NAME = "New Preset";
export const LINK_PLACEHOLDER = "custom link";
export const EXPIRE_SESSION_SECONDS = 7200;

export const DB_LINKS = "links";
export const DB_GUIDES = "guides";
export const DB_CLIENTS = "clients";
export const DB_PRESETS = "presets";
export const DB_SESSIONS = "sessions";

export const defaults = {
  size: 3,
  speed: 2500,
  angle: 0,
  pitch: 250,
  reverb: 0,
  duration: 70,
  volume: 0,
  wave: 0,
  length: 50,
  background: 1,
  opacity: 1,
  lightbar: 0,
  steps: 1,
  color: "white",
  shape: "circle",
  playing: false,
};

export const limits = {
  wave: { min: 0, max: 25, amplitude: 2.5 },
  angle: { min: -45, max: 45 },
  length: { min: 10, max: 50 },
  speed: { min: 250, max: 3000, nudge: 10 },
  volume: { min: 0, max: 1, step: 0.01, nudge: 0.05 },
  pitch: { min: 50, max: 2000 },
  reverb: { mind: 0, max: 1, step: 0.01 },
  duration: { min: 10, max: 250 },
  steps: { min: 1, max: 8 },
  lightbar: { min: 0, max: 0.5, step: 0.01 },
  background: { min: 0, max: 1, step: 0.01 },
  opacity: { min: 0, max: 1, step: 0.01 },
  size: { min: 1, max: 15, step: 0.1 },
  audioPanRange: 10000,
  toolbarHideDelay: 3000,
};
